import styled from 'styled-components';

import { cssBreakpoints } from 'theme';

export const IdealistLogoContainer = styled.div<{
  $heightMobile: number;
  $heightDesktop: number;
  $showStaffMarker?: boolean;
}>`
  display: inline-flex;
  align-items: center;

  --idealist-logo-height: ${(props) => props.$heightDesktop}px;

  @media screen and (max-width: ${cssBreakpoints.lgDown}) {
    --idealist-logo-height: ${(props) => props.$heightMobile}px;
  }

  height: var(--idealist-logo-height);
  gap: calc(var(--idealist-logo-height) / 4);
`;

export const IdealistLogoMarkImg = styled.img`
  display: inline-flex;
  height: 100%;
  aspect-ratio: 144 / 145;
  object-fit: contain;
  object-position: center;
`;

export const IdealistLogoTextImg = styled.img`
  height: 100%;
  aspect-ratio: 347.91 / 167.88;
  object-fit: contain;
  object-position: center;
`;

export const IdealistLogoStaffMarkerImg = styled.img`
  height: 100%;
  aspect-ratio: 184.44 / 167.88;
  object-fit: contain;
  object-position: center;
`;
